import { useEffect, useState } from "react";
import { slugify } from "../../data/cmsStore";
import { cmsAdminApi } from "../../api/cmsApi";

export default function AdminJobCategoriesPage() {
  const [categories, setCategories] = useState([]);
  const [name, setName] = useState("");
  const [editId, setEditId] = useState("");
  const [error, setError] = useState("");

  const refresh = async () => {
    try {
      setCategories(await cmsAdminApi.listJobCategories());
      setError("");
    } catch (e) {
      setError(e.message || "Could not load categories");
    }
  };
  useEffect(() => {
    refresh();
  }, []);

  const onSave = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    await cmsAdminApi.saveJobCategory({ id: editId || undefined, name: name.trim(), slug: slugify(name) });
    setName("");
    setEditId("");
    await refresh();
  };

  return (
    <div className="admin-page">
      <header className="admin-page-head">
        <div>
          <h1>Job Categories</h1>
          <p>Group career openings by department.</p>
        </div>
      </header>
      {error ? <p className="text-danger">{error}</p> : null}

      <form className="admin-panel admin-form admin-form--inline" onSubmit={onSave}>
        <label>
          {editId ? "Edit category" : "New category"}
          <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Category name" required />
        </label>
        <button type="submit" className="admin-btn admin-btn-primary">{editId ? "Update" : "Add"}</button>
        {editId ? (
          <button type="button" className="admin-btn admin-btn-ghost" onClick={() => { setEditId(""); setName(""); }}>Cancel</button>
        ) : null}
      </form>

      <div className="admin-panel">
        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Slug</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {categories.map((c) => (
                <tr key={c.id}>
                  <td>{c.name}</td>
                  <td><code>{c.slug}</code></td>
                  <td className="admin-actions">
                    <button type="button" className="admin-btn admin-btn-sm" onClick={() => { setEditId(c.id); setName(c.name); }}>Edit</button>
                    <button
                      type="button"
                      className="admin-btn admin-btn-sm admin-btn-danger"
                      onClick={async () => {
                        if (!window.confirm("Delete this category?")) return;
                        await cmsAdminApi.deleteJobCategory(c.id);
                        await refresh();
                      }}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
